import Client from './KomodoClient';

// komodo open platform: Komodo.SCM.Web/Controllers/Api/OpenPlatform/*.
const enc = encodeURIComponent;

const instances = () => Client.get('/api/partner-instance');
// Partner codes configured server-side (PartnerSetting.Secrets keys) → string[]
const partnerCodes = () => Client.get('/api/partner-instance/partners');
const createInstance = (dto) => Client.post('/api/partner-instance', dto);
const updateInstance = (pid, dto) =>
	Client.put(`/api/partner-instance/${enc(pid)}`, dto);
// Full webhook catalogue with the subscription state of this instance → PartnerWebhookDTO[]
const webhooks = (pid) => Client.get(`/api/partner-webhook/${enc(pid)}`);

export default {
	instances,
	partnerCodes,
	createInstance,
	updateInstance,
	webhooks,
};
